<button class="btn btn-success btn-edit mt-2 p-0" (click)="handleClick($event)"><i class="material-icons">edit</i>
  EDITAR</button>
<input type="file" style="display: none" #fileInput (change)="handleFileSelected($event)" accept="image/*">
